/**
 * Parse a German-format lap time ("m:ss,mmm", "." also accepted) to milliseconds.
 * Milliseconds are right-padded to 3 digits ("1:18,4" → 400 ms).
 * Returns null when the input doesn't match the format.
 */
export function parseLapTime(input: string): number | null {
    const m = /^(\d{1,2}):([0-5]\d)[,.](\d{1,3})$/.exec(input.trim());
    if (!m) return null;
    return parseInt(m[1], 10) * 60000 + parseInt(m[2], 10) * 1000 + parseInt(m[3].padEnd(3, '0'), 10);
}

/** Format milliseconds as a German lap time "m:ss,mmm" (matches race_results.best_lap). */
export function formatLapTime(ms: number): string {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    const millis = ms % 1000;
    return `${minutes}:${String(seconds).padStart(2, '0')},${String(millis).padStart(3, '0')}`;
}

/** Format a gap to the leader, e.g. "+0,532"; falls back to "+m:ss,mmm" over a minute. */
export function formatGap(ms: number): string {
    if (ms >= 60000) return `+${formatLapTime(ms)}`;
    const seconds = Math.floor(ms / 1000);
    const millis = ms % 1000;
    return `+${seconds},${String(millis).padStart(3, '0')}`;
}
